import React from 'react';
import { buildDependencyMaps } from '../adapters';

const RelationshipMapView = ({ open, fields, onClose, onGoToField }) => {
  if (!open) return null;
  const { dependsOn, usedBy } = buildDependencyMaps(fields);
  const labelOf = (code) => (fields || []).find((f) => f.fieldCode === code)?.fieldLabel || code;

  // Prefer a simple vertical flow of key semantic roles / totals
  const preferred = ['GROSS_WORK_DONE', 'GROSS_UPTO_DATE', 'CURRENT_RA_VALUE', 'NET_EXCL_SECURED_ADVANCE', 'TOTAL_RECOVERIES', 'TOTAL_WITHHELD', 'TOTAL_DEDUCTIONS', 'NET_PAYABLE'];
  const ordered = preferred
    .map((code) => (fields || []).find((f) => f.fieldCode === code || f.semanticRole === code))
    .filter(Boolean);
  const extras = (fields || []).filter((f) => !ordered.includes(f) && (dependsOn[f.fieldCode]?.length || usedBy[f.fieldCode]?.length));

  return (
    <div className="ra-tpl-modal-overlay" onClick={onClose}>
      <div className="ra-tpl-modal ra-tpl-modal--wide" onClick={(e) => e.stopPropagation()}>
        <h3>Relationship Map</h3>
        <p className="ra-tpl-help">Visualization of formula dependencies — not a second calculation definition.</p>
        <div className="ra-tpl-rel-flow">
          {ordered.map((f, idx) => (
            <React.Fragment key={f.fieldCode}>
              {idx > 0 && <div className="ra-tpl-rel-arrow">↓</div>}
              <button type="button" className="ra-tpl-rel-node" onClick={() => { onGoToField(f.fieldCode); onClose(); }}>
                {f.fieldLabel || f.fieldCode}
              </button>
            </React.Fragment>
          ))}
        </div>
        <div className="ra-tpl-rel-list">
          {(extras.length ? extras : fields || []).slice(0, 40).map((f) => (
            <div key={f.fieldCode} className="ra-tpl-rel-row">
              <button type="button" className="ra-tpl-chip ra-tpl-chip--btn" onClick={() => { onGoToField(f.fieldCode); onClose(); }}>
                {labelOf(f.fieldCode)}
              </button>
              <span>depends on {(dependsOn[f.fieldCode] || []).map(labelOf).join(', ') || '—'}</span>
            </div>
          ))}
        </div>
        <div className="ra-tpl-modal-actions">
          <button type="button" className="btn-primary" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
};

export default RelationshipMapView;
